/*** IMPORTS FROM imports-loader ***/
var define = false;

// src/js/pages/animations.js
import SplitText from '@lib/gsap-pro/SplitText';

export default {
  init(app, Menu, Kira, ScrollMagic, gsap) {
    const
      $body             = $('body'),
      $pageLoader       = $('.page-loader'),
      scrollAreas       = document.querySelectorAll('.scroll-area'),
      $splitItems       = $body.find('[data-splittext]'),
      $menuWrapper      = $('#mobile-menu'),
      $menuButton       = $('#header .btn-menu'),
      $menuBars         = $menuButton.find('.item-burger > span'),
      $menuClose        = $menuWrapper.find('.item-close'),
      $menuStaggerItems = $menuWrapper.find('[data-stagger-item]');

    $splitItems.each(function() {
      const $item = $(this);
      const split = new SplitText($item, {
        type: $item.data('splittext') || 'words, chars',
        linesClass: 'item-line',
        wordsClass: 'item-word',
        charsClass: 'item-char'
      });
      $item[0].split = split;
    });

    $body.on('loaderEnd', () => {
      $splitItems.addClass('split-ready');
    });

    scrollAreas.forEach(el => Scrollbar.init(el));

    const loaderTl = gsap.timeline({ paused: true });
    loaderTl
      .to($pageLoader.find('.item-loadbar-inner'), { duration: 0.4, scaleX: 1, ease: 'none' }, 'start')
      .to($pageLoader.find('.item-content'),      { duration: 0.8, autoAlpha: 0, ease: 'power1.out' }, 'start')
      .call(() => { app.dispachEvent($body, 'loaderEnd'); })
      .to($pageLoader,                           { duration: 0.8, autoAlpha: 0, ease: 'power1.out' });

    $(window).on('load', () => loaderTl.play());

    const menu = new Menu($menuWrapper, $menuButton, { reverseTimeScale: 2 });
    menu.menuTimeline
      .to($menuBars.eq(1), { duration: 0.3, autoAlpha: 0 }, 'start')
      .to($menuBars.eq(0), { duration: 0.5, x: 0, y:  8, rotation:  45, ease: 'power1.out' }, 'start')
      .to($menuBars.eq(2), { duration: 0.5, x: 0, y: -8, rotation: -45, ease: 'power1.out' }, 'start')
      .to($menuWrapper,   { duration: 0.5, autoAlpha: 1, ease: 'power1.out' }, 'start+=0.3')
      .staggerFrom($menuStaggerItems, 0.6, { autoAlpha: 0, x: 20, ease: 'power1.out' }, 0.1, 'start+=0.3');

    menu.init();

    const kira = new Kira(ScrollMagic, {
      debug: false,
      loadEvent: { domElement: $body, eventName: 'loaderEnd' },
      optimize: true,
      options: { start: '-=0.6', triggerHook: 'onEnter' }
    });

    kira.add('fadeInUp', ($item, timeline, start) => {
      timeline.fromTo($item,
        { y: 50 },
        { y: 0, autoAlpha: 1, duration: 1.3, ease: 'power1.out' },
        start
      );
    });

    kira.add('fadeInUp.parallax', ($item, timeline, start) => {
      timeline.fromTo($item,
        { y: 100 },
        { y: 0, autoAlpha: 1, duration: 0.8, ease: 'sine.out' },
        start
      );
    });

    kira.add('splitline', ($item, timeline, start) => {
      $item.find('.item-line').each(function() {
        timeline.from($(this).children(),
          { y: '101%', duration: 1.35, ease: 'power1.out' },
          start
        );
      });
    });

    kira.add('splittext.long', ($item, timeline, start) => {
      timeline.staggerFrom(
        $item[0].split.chars,
        0.8,
        { y: 5, opacity: 0, ease: 'sine.out' },
        $item.data('delay') || 0.01,
        start
      );
    });

    kira.add('fadeInLeft.stagger.sm', ($item, timeline, start) => {
      timeline.staggerFromTo(
        $item.find('[data-stagger-item]'),
        0.6,
        { x: 20 },
        { autoAlpha: 1, x: 0, ease: 'power1.out' },
        0.1,
        start
      );
    });

    kira.add('fadeInUp.stagger.sm', ($item, timeline, start) => {
      timeline.staggerFromTo(
        $item.find('[data-stagger-item]'),
        0.6,
        { y: 20 },
        { autoAlpha: 1, y: 0, ease: 'power1.out' },
        0.1,
        start
      );
    });

    kira.add('scaleX', ($item, timeline, start) => {
      timeline.from($item,
        { scaleX: 0, transformOrigin: 'left top', duration: 1, ease: 'expo.inOut' },
        start
      );
    });

    kira.init();
  }
};

